import "../../Styles/Auth/Signup.css";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import SectionOneLB1 from "../../Assets/SectionOneLB1.png";
import { signup } from "../../APIService";
import { ZGAContext } from "../../ZGAContext";

const Signup = () => {
  const navigate = useNavigate();
  const { showSuccessModal, setIsSubmitting } = useContext(ZGAContext);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [signupInfo, setSignupInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const confirmDisable = signupInfo.password === confirmPassword;

  function handleSignupChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    setSignupInfo((prevSignupInfo) => {
      return {
        ...prevSignupInfo,
        [name]: value,
      };
    });
  }

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await signup(signupInfo);
      showSuccessModal("Signup successful!", true, "/auth/login", "Login");
    } catch (error) {
      showSuccessModal(`${error.response?.data?.message || "Signup failed. Please try again."}`, false, "", "");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Test34@gmail.com and Test34.Test34

  return (
    <div className="signup">
      <div>
        <h1>SIGN UP</h1>
        <form onSubmit={handleSignup}>
          <fieldset>
            <label>
              First name
              <input type="text" name="firstName" value={signupInfo.firstName} onChange={handleSignupChange} required />
            </label>
            <label>
              Last name
              <input type="text" name="lastName" value={signupInfo.lastName} onChange={handleSignupChange} required />
            </label>
            <label>
              Email address
              <input type="email" name="email" required value={signupInfo.email} onChange={handleSignupChange} />
            </label>
            <label>
              Password
              <input
                type="password"
                name="password"
                required
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                value={signupInfo.password}
                onChange={handleSignupChange}
              />
            </label>
            <label>
              Confirm password
              <input
                type="password"
                name="confirmPassword"
                required
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
              />
              {!confirmDisable && <span>** Password does not match</span>}
            </label>
          </fieldset>
          <div>
            <input type="submit" name="submit" value="SIGN UP" disabled={!confirmDisable} />
            <span>
              Already have an account? <span onClick={() => navigate("/auth/login")}>Login</span>
            </span>
          </div>
        </form>
      </div>
      <div>
        <img src={SectionOneLB1} alt="Background" />
        <div className="gradient"></div>
      </div>
    </div>
  );
};

export default Signup;
